/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  document.querySelectorAll('.quick-add-form').forEach((form) => {
    const idInput  = form.querySelector('input[name="id"]');
    const submitEl = form.querySelector('[data-add-to-cart]');

    form.addEventListener('change', (e) => {
      // accept any radio; don't require data-variant-id
      const radio = e.target.matches('input[type="radio"]')
        ? e.target
        : e.target.closest('input[type="radio"]');

      if (!radio || !radio.checked) return;

      // prefer data-variant-id, fall back to the radio's id, then value
      const variantId = radio.dataset.variantId || radio.id || radio.value;
      if (!variantId) {
        console.warn('No variant id on radio. Add data-variant-id or set the radio id to the variant id.');
        return;
      }

      idInput.value = variantId;

      if (submitEl) submitEl.click();
    });
  });
    
  const productMediaObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.click();
      }
    });
  },
  { rootMargin: '0px 0px 250px 0px' }
);

document.querySelectorAll('[data-deferred-media-button]').forEach((el) => productMediaObserver.observe(el));

  const atc = document.querySelector('[data-add-to-cart-text]');  
  let lastText = atc.textContent;

  const observer = new MutationObserver(() => {
    const currentText = atc.textContent;
    if (currentText !== lastText) {
      lastText = currentText;
      atc.style.opacity = 1;
    }
  });

  observer.observe(atc, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setTimeout(() => {
    atc.style.opacity = 1;
  }, 3000)

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();